/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Summarysourcepulsify2Inputs */

const en_summarysourcepulsify2 = /** @type {(inputs: Summarysourcepulsify2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pulsify website`)
};

const de_summarysourcepulsify2 = /** @type {(inputs: Summarysourcepulsify2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pulsify-Website`)
};

/**
* | output |
* | --- |
* | "Pulsify website" |
*
* @param {Summarysourcepulsify2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const summarysourcepulsify2 = /** @type {((inputs?: Summarysourcepulsify2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Summarysourcepulsify2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_summarysourcepulsify2(inputs)
	return de_summarysourcepulsify2(inputs)
});
export { summarysourcepulsify2 as "summarySourcePulsify" }